const axios = require('axios');
const oauth = require('axios-oauth-client');
const tokenProvider = require('axios-token-interceptor');
import store from '@/store.js';
 


export default async function interceptorsSetup(instance, opt = null) {

	//code
	//refresh_token
	// var options = opt;
	
    if (opt !== null) {
    	if (!opt.code) {
	    	const url = new URL(location, location);
	    	const search = urlToObj(url.search.substring(1));
	        const code = search.code;
	        opt.code = code;
	    }
	    window.localStorage.setItem('authorization', JSON.stringify(opt));
    }
	//console.debug('interceptorsSetup: code %s %o', options.code, options);

	// https://www.npmjs.com/package/axios-token-interceptor
	// https://www.npmjs.com/package/axios-oauth-client

async function getOwnerCredentials () {
	//console.debug("> getToken(): %o %o", options.code, options.token);
	const authorization = JSON.parse(window.localStorage.getItem('authorization'));
	if (authorization === null) {
		return {
			access_token: "",
			token_type: "Bearer",
		};
	}
    if(authorization.code !== null){
    	//console.debug("from code: %o %o", options.code, options.token);
		const client = oauth.client(axios.create(), {
			url: authorization.tokenUrl, //'https://oauth.com/2.0/token',
			grant_type: 'authorization_code',
		    client_id: authorization.clientId,
		//    client_secret: 'bar',
		    redirect_uri: authorization.ret,
		    code: authorization.code,
//	        scope: options.scope,
		  });
		authorization.token = await client();
		authorization.code = null;
		window.localStorage.setItem('authorization', JSON.stringify(authorization));
		//console.debug("after code: %o %o %o", options.code, client, options.token);
		return authorization.token;
//		return client;
    }
	else {
		//console.debug("from refresh_token: %o ", options.token);
		const client = oauth.client(axios.create(), {
			url: authorization.tokenUrl, //'https://oauth.com/2.0/token',
			grant_type: 'refresh_token',
		    client_id: authorization.clientId,
		//    client_secret: 'bar',
	       refresh_token: authorization.token.refresh_token,
//	        scope: options.scope,
		    });
		authorization.token = await client();
		// authorization.code = null;
		// window.localStorage.setItem('authorization', JSON.stringify(authorization));
		//console.debug("after refresh_token: %o ", token);
		return authorization.token;
//		return client;
		}
    } // getToken()
    
	function urlToObj(str) {
	    return str
	      .split('&')
	      .map((v) => v.split('='))
	      .reduce( (pre, [key, value]) => ({ ...pre, [key]: value }), {} );
	  }

//console.warn('getOwnerCredentials: %o', getOwnerCredentials);
//console.warn('getOwnerCredentials: %o', getOwnerCredentials());
//console.warn('GetCredentialsObj: %o', new GetCredentials({tokenUrl:tokenUrl, clientId:clientId, ret:ret}).getToken );
//console.warn('GetCredentialsObjV: %o', await new GetCredentials({tokenUrl:tokenUrl, clientId:clientId, ret:ret}).getToken());
 
//const instance = axios.create();
instance.interceptors.request.use(
  // Wraps axios-token-interceptor with oauth-specific configuration,
  // fetches the token using the desired claim method, and caches
  // until the token expires
    oauth.interceptor(tokenProvider, getOwnerCredentials)
    /*, function (error) {
    console.error("Que mala onda: Error interceptor: %o",error);
    return Promise.reject(error);
  }*/
    
);

	instance.interceptors.response.use((response) => {
		return response;
	}, (error) => {
		console.error('interceptors response error: ', error);
		if (error.response.status === 401 || error.response.status === 403) {
			store.dispatch('logout');
		}
		throw error;
	});
}
